import { styled } from '@mui/material';

export const ListW = styled('div')(
  ({ theme }) => `
  border: 1px solid ${theme.palette.info.dark};
  border-radius: 8px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
`,
);
